import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Url, URLS } from '@wix/da-url';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { BiData } from '@wix/da-bi/pkg/events';
import { UserMenuContext } from '../UserMenuMobile/UserMenuContext';
export function useBillingItem() {
    const { t } = useTranslation();
    const { isOpen: isUserMenuOpen } = useContext(UserMenuContext);
    const isMobile = useContext(MobileContext);
    return {
        label: t('siteHeader.userMenu.myOrderHistory'),
        link: Url.buildFromPath(URLS.ORDERS),
        biData: BiData({
            evid: 702,
            link_url: Url.buildFromPath(URLS.ORDERS),
            menu_item: 'order_history',
            menu_name: 'profile'
        }),
        tabIndex: isUserMenuOpen || !isMobile ? 0 : -1
    };
}
